import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditTextModal = ({ show, onClose, onSave, fieldType, initialValue, isSaving = false }) => {
  const [text, setText] = useState(initialValue || '');

  useEffect(() => {
    setText(initialValue || '');
  }, [initialValue]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit {fieldType}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          {fieldType === 'Title' ? (
            <Form.Control
              type="text"
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder={`Enter ${fieldType}`}
            />
          ) : (
            <Form.Control
              as="textarea"
              rows={4}
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder={`Enter ${fieldType}`}
            />
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSaving}>Cancel</Button>
        <Button variant="primary" onClick={() => onSave(text)} disabled={isSaving}>
          {isSaving ? (
            <>
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              Saving...
            </>
          ) : (
            'Save'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTextModal;
